<template>
    <LoaderCar v-if="loading" width="600px" marginTop="0"/>
    <div class="piece-eleve" v-else>
        <HeaderHome :user="this.$store.state.user.prenom"/>
        <div class="piece-content">
            <div class="greeting">
                <div class="title-page">
                    <p class="path"><span @click="goToHome">Accueil</span> > <span>Pièce Dossier</span></p>
                    <p class="title">Pièce Dossier</p>
                    <p class="subtitle">Déposez vos pièces justificatives pour valider votre inscription</p>
                </div>
                <div class="avancement">
                    <p class="title-part">AVANCEMENT</p>
                    <div class="bar-avancement"><div class="progress-avancement" :style="{ width: pourcent}"></div></div>
                    <p class="info-bar"><span>{{ pieceGood }} pièce<span v-if="pieceGood > 1">s</span> </span> acceptée sur {{ $store.state.dossier.pieceJustificatives.length }}</p>
                </div>
            </div>

            <div class="pieces">
                <template v-for="item in $store.state.dossier.pieceJustificatives" :key="item.id">
                    <PieceJustif status="incomplet" :piece="item" :student="null"/>
                </template>
            </div>

        </div>
    </div>
</template>
<script>
import PieceJustif from '../../../components/eleve/dossier/PieceJustif.vue';
import HeaderHome from '../../../components/home/HeaderHome.vue';
import LoaderCar from '../../../components/LoaderCar.vue';

export default {
    name: "Piece",

    components: {
        HeaderHome,
        PieceJustif,
        LoaderCar
    },
    
    data() {
        return {
            loading: true,
            pourcent: 0,
            pieceGood: 0,
        }
    },

    mounted() {
        this.loadDossier();
    },

    methods: {

        goToHome(){
            this.$router.push({ name: "Home" });
        },

        async loadDossier() {
        try {
            // Charge les types de pièces justificatives pour pouvoir recalculer les pièces de l'utilisateur
            window.api
                .get("/type_piece_justificative", {
                    headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    },
                })
                .then((response) => {
                    // Place dans le store les types de pièce justificatives
                    this.$store.state.typePieceJustificative =
                    response.data["hydra:member"];
                    // Si l'utilisateur a un dossier
                    if (this.$store.state.user.dossier !== null) {
                    // Charge le dossier pour pouvoir recalculer les pièces de l'utilisateur
                    window.api
                        .get("/dossiers/" + this.$store.state.user.dossier.id, {
                        headers: {
                            Authorization: "Bearer " + this.$store.state.token,
                        },
                        })
                        .then((response) => {
                        // Place le dossier dans le store
                        this.$store.state.dossier = response.data;
                        // Initialisation de typePieces avec les pièces permanente
                        let typePieces =
                            this.$store.state.typePieceJustificative.filter(
                            (el) => el.useCase === "dossier"
                            );
                        // Calcul de l'age
                        let age =
                            new Date().getUTCFullYear() -
                            new Date(
                            this.$store.state.dossier.dateNaissance
                            ).getUTCFullYear();

                        // Suivant des conditions, différents type de pièce sont ajoutés à typePieces

                        // Si l'élève a entre 17 ans inclus et 25 ans exclu
                        if (age >= 17 && age < 25) {
                            Array.prototype.push.apply(
                            typePieces,
                            this.$store.state.typePieceJustificative.filter(
                                (el) => el.useCase === "age"
                            )
                            );
                        }
                        // Si la demande fait suite à une annulation/invalidation de permis
                        if (this.$store.state.dossier.faitSuite) {
                            Array.prototype.push.apply(
                            typePieces,
                            this.$store.state.typePieceJustificative.filter(
                                (el) => el.useCase === "faitSuite"
                            )
                            );
                            // Si l'annulation/invalidation est lié à l'alcool ou la drogue
                            if (this.$store.state.dossier.motifAlcoolStup) {
                            Array.prototype.push.apply(
                                typePieces,
                                this.$store.state.typePieceJustificative.filter(
                                (el) => el.useCase === "faitSuite/oui"
                                )
                            );
                            } else {
                            Array.prototype.push.apply(
                                typePieces,
                                this.$store.state.typePieceJustificative.filter(
                                (el) => el.useCase === "faitSuite/non"
                                )
                            );
                            }
                        }
                        // Mise à jour des pièces relatives à l'utilisateur
                        window.api
                            .post(
                            "/dossier/piece",
                            {
                                dossier: this.$store.state.dossier,
                                typePieces: typePieces,
                            },
                            {
                                headers: {
                                Authorization: "Bearer " + this.$store.state.token,
                                },
                            }
                            )
                            .then((response) => {
                            // Place dans le store le dossier après mise à jour des pièces
                            this.$store.state.dossier = response.data;
                            this.loadDossierFinish = true;
                            // Déplace ici le calcul et le loading
                            this.pieceGood = this.$store.state.dossier.pieceJustificatives.filter((e) => e.etat === true).length;
                            this.pourcent = (this.pieceGood / this.$store.state.dossier.pieceJustificatives.length) * 100 + "%";
                            this.loading = false; // ← ici, plus de setTimeout
                            })
                            .catch((error) => {
                            // En cas d'échec de mise à jour des pièces, retour au menu home
                            this.$router.push({ name: "Home" });
                            console.log(error);
                            });
                        })
                        .catch((error) => {
                        // En cas d'échec du chargement du dossier, retour au menu home
                        this.$router.push({ name: "Home" });
                        console.log(error?.response?.data?.message ?? error.message);
                        });
                    } else {
                    // Sinon, retour au menu home
                    this.$router.push({ name: "Home" });
                    }
                    
                })
                .catch((error) => {
                    // En cas d'échec au chargement des types de pièce justificatives, retour au menu home
                    this.$router.push({ name: "Home" });
                    console.log(error?.response?.data?.message ?? error.message);
                });
            } catch (e) {
                // En cas d'erreur, retour au menu home
                this.$router.push({ name: "Home" });
            }
        },
    },
}
</script>
<style scoped>

    div.piece-eleve{
        background-color: #F4F6F9;
        min-height: 100vh;
        padding-bottom: 1rem;
        text-align: left;
    }

    div.piece-eleve div.piece-content{
        width: 70%;
        margin: auto;
        margin-top: 2rem;
    }

    div.piece-eleve div.piece-content div.greeting{
        display: flex;
        justify-content: space-between;
    }

    div.piece-eleve div.piece-content div.greeting p.path{
        font-size: 17px;
        color: #64748b;
        margin: 0;
    }

    div.piece-eleve div.piece-content div.greeting p.path span:hover{
        cursor: pointer;
        color: #8AA1BE;
    }

    div.piece-eleve div.piece-content div.greeting p.title{
        font-size: 40px;
        font-weight: bold;
        margin: 0;
    }

    div.piece-eleve div.piece-content div.greeting p.subtitle{
        font-size: 17px;
        color: #64748b;
    }

    div.piece-content div.greeting div.avancement{
        background-color: white;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 20px;
        text-align: right;
    }

    div.piece-content div.greeting div.avancement p{
        margin: 0;
    }

    div.greeting div.avancement p.info-bar span{
        color: #24B27E;
    }

    div.greeting div.avancement div.bar-avancement{
        background-color: #F4F6F9;
        border-radius: 20px;
        width: 100%;
        height: 10%;
    }

    div.greeting div.avancement div.bar-avancement div.progress-avancement{
        width: 20%;
        background-color: #24B27E;
        height: 100%;
        border-radius: 20px;
    }

    div.piece-content div.greeting div.avancement p.title-part{
        color: #64748b;
        margin-bottom: 10px;
    }

    div.pieces{
        display: grid;
        grid-template-columns: repeat(3, 1fr); /* 2 colonnes */
        gap: 10px; 
        margin-top: 3rem;
    }

    @media (max-width: 1600px){
        div.pieces{
            display: grid;
            grid-template-columns: repeat(2, 1fr); /* 2 colonnes */
            gap: 10px; 
            margin-top: 3rem;
        }
    }

    @media (max-width: 1200px){
        div.pieces {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 10px;
            margin-top: 3rem;
            overflow: hidden;
        }
    }

    
</style>